<template>
    <div>
<!--        交付数据的数据整理页面-->
        <v-overlay light absolute opacity="0.5" style="width: 100%;height:100%;" v-if="$store.state.showPanel">
            <DeliveryDataArrange class="move-file"></DeliveryDataArrange>
        </v-overlay>
        <!--  下载链接  -->
        <div class="download" v-if="$store.state.showCopyFile">
            <div style="opacity: 0.5;background-color: #101010;position: absolute;top: 0px;left: 0px;width: 100%;height: 100%;"></div>
            <CopyFile></CopyFile>
        </div>
        <!--  修改密码页面  -->
        <div class="download" v-if="$store.state.changePassword">
            <div style="opacity: 0.5;background-color: #101010;position: absolute;top: 0px;left: 0px;width: 100%;height: 100%;"></div>
            <ChangePassword></ChangePassword>
        </div>
<!--        缩略图点击放大原图-->
        <v-overlay absolute v-if="$store.state.showOriginImage" style="top: 0px;">
            <div :style="{width: (imageWidth-100)+'px', 'height':(imageWidth-100)+'px'}">
                <img style="width: 100%;height: 100%;" :src="'/jpgapi/jpg/v2/thumbnail/mss/'+ $store.state.bifProductId">
            </div>
            <div style="position: absolute;top:0px;right:-20px;width: 20px; height: 20px;background-color: rgba(0,0,0,0.75);z-index: 19;">
                <img @click="$store.state.showOriginImage=false" style="width: 100%;height: 100%;cursor: pointer;" tltle="关闭地图选点" src="../assets/whiteClose.png">
            </div>
        </v-overlay>
<!--        范围浏览leaflet-->
        <v-overlay v-if="$store.state.mapShowDialog">
            <v-card style="width: 700px; height: 480px;">
                <l-map style="width: 100%; height: 100%;" :options="options" :bounds.sync="$store.state.bounds">
                    <l-tile-layer :url="$store.state.servicePath.tdtVecUrl" :options="subdomains" />
                    <l-tile-layer :url="$store.state.servicePath.tdtVecBzUrl" :options="subdomains" />
                    <l-geo-json :geojson="$store.state.geo" :optionsStyle="targetGeojsonStyle"/>
                </l-map>
                <div style="position: absolute;top:0px;right:-20px;width: 20px; height: 20px;background-color: rgba(0,0,0,0.75);">
                    <img @click="$store.state.mapShowDialog=false" style="width: 100%;height: 100%;cursor: pointer;" tltle="关闭地图选点" src="../assets/whiteClose.png">
                </div>
            </v-card>
        </v-overlay>
<!--        裁剪范围-->
        <v-overlay v-if="$store.state.showClipMap">
            <v-card style="width: 700px; height: 480px;">
                <l-map style="width: 100%; height: 100%;" :options="options" :bounds.sync="$store.state.bounds">
                    <l-tile-layer :url="$store.state.servicePath.tdtVecUrl" :options="subdomains" />
                    <l-tile-layer :url="$store.state.servicePath.tdtVecBzUrl" :options="subdomains" />
                    <l-geo-json :geojson="$store.state.geo" :optionsStyle="targetGeojsonStyle"/>
                </l-map>
                <div style="position: absolute;top:0px;right:-20px;width: 20px; height: 20px;background-color: rgba(0,0,0,0.75);">
                    <img @click="$store.state.showClipMap=false" style="width: 100%;height: 100%;cursor: pointer;" tltle="关闭地图选点" src="../assets/whiteClose.png">
                </div>
            </v-card>
        </v-overlay>
    </div>
</template>
<script>
    import DeliveryDataArrange from "../components/main/DeliveryDataArrange";
    import CopyFile from "../components/main/CopyFile";
    import { LGeoJson, LMap, LTileLayer } from "vue2-leaflet";
    import ChangePassword from "../components/main/ChangePassword";
    
    export default {
        name: "Overlay",
        components: {
            ChangePassword,
            DeliveryDataArrange,
            CopyFile,
            LMap, LTileLayer, LGeoJson
        },
        data(){
            return {
                options: { zoomControl: false, attributionControl: false },
                subdomains: { subdomains: ['0', '1', '2', '3'] },
                targetGeojsonStyle: { color: '#00BCD4', weight: 2, fillOpacity: 0 },
            }
        },
        props: [ "imageWidth" ],
    }
</script>
<style scoped>
    .move-file {
        top: 20%;
        left: 35%;
        width: 790px;
        height: 550px;
    }
    .download {
        position: absolute;
        top: 0px;
        left: 0px;
        z-index: 5;
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>